module.exports = __webpack_public_path__ + "img/hz_25.59e96466.jpg";